const state = {
  brandOptionsAll: [],
  seriesOptionsAll: [],
  styleOptionsAll: [],
  themeGroup: {}
};

// getters
const getters = {
  getBrandOptionsAll: state => state.brandOptionsAll,
  getSeriesOptionsAll: state => state.seriesOptionsAll,
  getStyleOptionsAll: state => state.styleOptionsAll,
  getThemeGroup: state => state.themeGroup,
};

// mutations
const mutations = {
  setBrandOptionsAll(state, options) {
    state.brandOptionsAll = options;
    var series = []
    var style = []
    options.forEach(element => {
      series = series.concat(element.vehicleSeriesList)
      element.vehicleSeriesList.forEach(ele => {
        style = style.concat(ele.vehicleModelList)
      })
    });
    state.seriesOptionsAll = series
    state.styleOptionsAll = style
  },
  setThemeGroup(state, themeGroup) {
    state.themeGroup = themeGroup
  }
};

// actions
const actions = {};

export default {
  state,
  getters,
  actions,
  mutations,
};